<template>
  <div>
    <div v-if="error" class="c-message">
      <div class="c-message__info has-error">
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 0a9 9 0 109 9 9.026 9.026 0 00-9-9zm3.713 11.652l-1.061 1.06L9 10.06l-2.652 2.652-1.06-1.06L7.938 9 5.287 6.348l1.061-1.06L9 7.938l2.652-2.652 1.06 1.061L10.06 9l2.652 2.652z"
            fill="#DF2137"
          />
        </svg>
        <span>Error:</span> {{ error }}
      </div>
    </div>
    <div v-if="selectedMovie">
      <div v-if="selectedMovie.Slug">
        <router-view></router-view>
      </div>
      <div v-else>
        <page404 />
      </div>
    </div>
  </div>
</template>

<script>
import page404 from '@/views/pages/404';
export default {
  name: 'steps',
  props: {
    title: String
  },
  components: { page404 },
  data() {
    return {
      error: ''
    };
  },
  computed: {
    selectedMovie() {
      return this.$store.getters['movies/selectedMovie'];
    }
  },
  created() {
    this.$store.dispatch('levelChanged', 0);
    this.$store.dispatch('movies/loadMovie', { title: this.title }).catch(e => {
      this.error = e;
    });
  }
};
</script>
